module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "background-social.9d56e730.png";